export const CRITICALITIES = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  URGENT: 'URGENT',
};

export const CRITICALITIES_DISPLAY_NAME = {
  [CRITICALITIES.LOW]: 'Faible',
  [CRITICALITIES.MEDIUM]: 'Moyenne',
  [CRITICALITIES.HIGH]: 'Élevée',
  [CRITICALITIES.URGENT]: 'Urgent',
};
